import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnLabel from "@shared/components/SnLabel";
import SnNumberBox from "@shared/components/SnNumberBox";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PUR_RCV_REG_002_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);

    const inputRefs = useRef<any>([]);
    const isSyncingCheckbox = useRef(false);

    const [gridFocus1, setGridFocus1] = useState(false);
    const [gridFocus2, setGridFocus2] = useState(false);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridApiRef1.current.getCheckedRows() || [],
        gridApiRef2.current.getCheckedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_PUR_RCV_REG_002_POP_002", {});
          const mergedData: any = {
            ...rtn.formData,
            ...selectedData,
            fg_trns: "2",
          };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    useEffect(() => {
      gridApiRef1.current.selectAndFocusRow(0);
      gridApiRef2.current.selectAndFocusRow(0);
      setGridFocus1(false);
      setGridFocus2(false);
    }, [gridFocus1, gridFocus2]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_pur_rcv_reg_002_pop_02",
            params: searchRef.current.getFormdata(),
          };
          setDataSource1([]);
          setDataSource2([]);

          const data: any = await fnGetDataSet(param);

          setDataSource1(data[0]);
          setDataSource2(data[1]);

          if (data[0] && data[0].length > 0) {
            //const selectNoEst = data[0][0];
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus1(true);
            setGridFocus2(true);
          }

          gridApiRef1.current?.selectAndFocusRow(0);
          gridApiRef2.current?.selectAndFocusRow(0);
          gridApiRef1.current.resetUpdate();
          gridApiRef2.current.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event?.data || event;

      if (selectedRow) {
        const cd_po = selectedRow.cd_po;
        const cd_cust = selectedRow.cd_cust;
        gridApiRef2.current.applyFilters({
          cd_cust: cd_cust,
          cd_po: cd_po,
        });

        gridApiRef2.current.selectAndFocusRow(0);
      }
    };

    const onCellValueChangedH = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { no_po } = updatedRow;

      const isParentGrid =
        gridApiRef1.current.api.getRowNode(event.node.id) !== undefined;

      const isHeaderCheckbox = event.source === undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        if (isHeaderCheckbox) {
          gridApiRef2.current.api.forEachNode((node: any) => {
            node.setDataValue("fixCheckbox", isChecked);
          });
        } else {
          gridApiRef2.current.api.forEachNodeAfterFilter((node: any) => {
            node.setDataValue("fixCheckbox", isChecked);
          });
        }
      } else {
        const matchingChildren: any[] = [];
        gridApiRef2.current.api.forEachNodeAfterFilter((node: any) => {
          const child = node.data;
          matchingChildren.push(child);
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);
        gridApiRef1.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (parent.no_po === no_po) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }

      // Reset flag after short delay (next tick)
      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };

    const onCellValueChangedL = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { no_po } = updatedRow;

      const isParentGrid =
        gridApiRef2.current.api.getRowNode(event.node.id) !== undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        gridApiRef1.current.api.forEachNodeAfterFilter((node: any) => {
          if (node.data.no_po === no_po) {
            node.setDataValue("fixCheckbox", isChecked);
          }
        });
      } else {
        const matchingChildren: any[] = [];
        gridApiRef1.current.api.forEachNodeAfterFilter((node: any) => {
          const child = node.data;
          matchingChildren.push(child);
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);
        gridApiRef2.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (parent.no_po === no_po) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }
      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };

    //#endregion

    //#region UI
    return (
      <div style={{ position: "relative" }}>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>
        <div style={{ height: "28vh" }}>
          <SnGrid
            ref={gridApiRef1}
            columnConfig={columns1}
            rowData={dataSource1}
            rowSelection="single"
            isEditable={false}
            enableAddRow={false}
            onFocusedRowChanged={onFocusedRowChanged}
            ischeckboxSelection={true}
            onCellValueChanged={onCellValueChangedH}
          />

          <SnGrid
            ref={gridApiRef2}
            columnConfig={columns2}
            rowData={dataSource2}
            rowSelection="multiple"
            isEditable={false}
            enableAddRow={false}
            ischeckboxSelection={true}
            onCellValueChanged={onCellValueChangedL}
          />
        </div>
      </div>
    );
    //#endregion
  }
);

export default SN_PUR_RCV_REG_002_POP_002;
